import { RootState, AppDispatch } from 'src/store/store';
import { connect } from 'react-redux';
import HomePage from './HomePage';
import { GetContainerDetailsInput } from 'src/models/GetContainerDetails';
import { fetchContainerDetails } from 'src/store/common-slices/getContainerSlice';


const mapStateToProps = (state: RootState) => ({
    accessibleTools: state.Init.initData.associateDetails.accessibleTools,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => dispatch(fetchContainerDetails(getContainerDetailsInput))
});

export default connect(mapStateToProps, mapDispatchToProps) (HomePage);
